export const TXT_CONTACT_US = "contattaci";
export const TXT_CUSTOMER_SERVICE_CONTACT = "C’è un problema su questa SIM. Contatta il Servizio Clienti";
export const TXT_SHARED_WALLET_LESS_THAN_3000 = "Il credito del tuo wallet condiviso è inferiore a 3.000 €";
export const TXT_RECHARGE = "ricarica";
export const TXT_REMAINING_CREDIT = "Il credito residuo è in esaurimento";
export const TXT_IN_CESSATION = "in cessazione";
export const TXT_SIM_SUSPENDED = "sim sospesa";
export const TXT_IN_ACTIVATION = "in attivazione";
export const TXT_IN_ACTIVATION_PORTABILITY_REQUEST = "In Attivazione - Richiesta Portabilità";
export const TXT_IN_ACTIVATION_PORTABILITY_CHANGE = "In Attivazione - Variazione Portabilità";
export const TXT_NUMBER_TO_BRING = "Numero da portare";
export const TXT_REQUESTED_DATE = "Data Richiesta";
export const TXT_CHANGE_IN_PROGRESS = "Variazione - cambio piano in corso";
export const TXT_CHANGE_COST_CENTER_IN_PROGRESS = "Variazione - cambio centro di costo in corso";
export const TXT_CHANGE_QUALIFICATION_CLASS_IN_PROGRESS = "Variazione - modifica classe di abilitazione in corso";

export const TXT_RICHIEDI_MODIFICA = "Richiedi modifica";

export const TXT_VOCE_VERSO_NUMERI_AZIENDALI = "voce verso numeri aziendali";
export const TXT_VOCE_VERSO_NUMERI_NAZIONALI = "voce verso numeri nazionali";
export const TXT_VOCE_VERSO_NUMERI_INTERNAZIONALI = "voce verso numeri internazionali";
export const TXT_DATI = "dati";
export const TXT_SMS_VERSO_NUMERI_NAZIONALI = "SMS verso numeri nazionali";
export const TXT_SMS_VERSO_NUMERI_INTERNAZIONALLI = "SMS verso numeri internazionali";
export const TXT_VOCE = "voce";
export const TXT_SMS = "SMS";

//Screen Codes for Service Requests
export const E5_01_B_03 = "E5.01.B.03";
export const E5_01_B_04 = "E5.01.B.04";
export const E5_01_B_05 = "E5.01.B.05";
export const E2_01_D_03_9 = "E2.01.D.03-9";
export const E2_01_D_03_10 = "E2.01.D.03-10";
export const E5_01_C_13 = "E5.01.C.13";
export const E63 = "E63"

export const SOM_SIM_BLOCK = "SIM_BLOCK";
export const SOM_SIM_MODIFY_GRUPPO_RAM = "SIM_MODIFY_GRUPPO_RAM";

export const DUAL_BILLING_ENABLE = "DUAL_BILLING_ENABLE";
